/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Allocations_Empty_Past_DescriptionInputs */

const en_admin_resources_resource_allocations_empty_past_description = /** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_Past_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocations that have ended appear here once they are no longer active.`)
};

const de_admin_resources_resource_allocations_empty_past_description = /** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_Past_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergangene Zuweisungen erscheinen hier, sobald sie nicht mehr aktiv sind.`)
};

const es_admin_resources_resource_allocations_empty_past_description = /** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_Past_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las asignaciones que han finalizado aparecen aquí una vez que ya no están activas.`)
};

const fr_admin_resources_resource_allocations_empty_past_description = /** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_Past_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les attributions terminées apparaissent ici une fois qu'elles ne sont plus actives.`)
};

/** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_Past_DescriptionInputs) => LocalizedString} */
const it_admin_resources_resource_allocations_empty_past_description = en_admin_resources_resource_allocations_empty_past_description;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_Past_DescriptionInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_allocations_empty_past_description = en_admin_resources_resource_allocations_empty_past_description;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_Past_DescriptionInputs) => LocalizedString} */
const pl_admin_resources_resource_allocations_empty_past_description = en_admin_resources_resource_allocations_empty_past_description;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_Past_DescriptionInputs) => LocalizedString} */
const hu_admin_resources_resource_allocations_empty_past_description = en_admin_resources_resource_allocations_empty_past_description;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_Past_DescriptionInputs) => LocalizedString} */
const ro_admin_resources_resource_allocations_empty_past_description = en_admin_resources_resource_allocations_empty_past_description;

/**
* | output |
* | --- |
* | "Allocations that have ended appear here once they are no longer active." |
*
* @param {Admin_Resources_Resource_Allocations_Empty_Past_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_allocations_empty_past_description = /** @type {((inputs?: Admin_Resources_Resource_Allocations_Empty_Past_DescriptionInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Allocations_Empty_Past_DescriptionInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_allocations_empty_past_description(inputs)
	if (locale === "de") return de_admin_resources_resource_allocations_empty_past_description(inputs)
	if (locale === "es") return es_admin_resources_resource_allocations_empty_past_description(inputs)
	if (locale === "fr") return fr_admin_resources_resource_allocations_empty_past_description(inputs)
	if (locale === "it") return it_admin_resources_resource_allocations_empty_past_description(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_allocations_empty_past_description(inputs)
	if (locale === "pl") return pl_admin_resources_resource_allocations_empty_past_description(inputs)
	if (locale === "hu") return hu_admin_resources_resource_allocations_empty_past_description(inputs)
	return ro_admin_resources_resource_allocations_empty_past_description(inputs)
});
export { admin_resources_resource_allocations_empty_past_description as "admin.resources.resource_allocations.empty_past_description" }